import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dee2df10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "model-list" }
const _hoisted_2 = { class: "ws_common_operation" }
const _hoisted_3 = { class: "table" }

import { ref, onMounted } from 'vue'
import { PAGE_SIZES, CODE_ENUM } from '@/common'
import { msgbox } from '@/utils'
import moment from 'moment'
import OperationButtonList from '@/components/operation-button-list'
import { useRouter } from 'vue-router'
import TemplateForm from './components/template-form.vue'
import { queryDeviceThingTemplatePage, deviceThingTemplateDelete } from '@/api'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()

const tableData: any = ref([])

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

const handleSizeChange = () => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = () => {
  fetchList()
}
const tableLoading = ref(false)

const fetchList = async () => {
  tableLoading.value = true
  const res: any = await queryDeviceThingTemplatePage({
    ...pageParams.value,
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}

onMounted(() => {
  fetchList()
})

const templateConf: any = ref({
  visible: false,
  data: {},
})

const toTemplateForm = (data = {}) => {
  templateConf.value = {
    visible: true,
    data,
  }
}

const buttonList = ref([
  {
    type: 'model',
    text: '物模型管理',
  },
  {
    type: 'edit',
    text: '编辑',
  },
  {
    type: 'delete',
    text: '删除',
  },
])

const col = [
  {
    prop: 'modelName',
    label: '模板名称',
  },
  {
    prop: 'createDate',
    label: '创建时间',
    formatter: ({ createDate }: any) => {
      return moment(createDate).format('YYYY-MM-DD HH:mm:ss')
    },
  },
  {
    prop: 'remarks',
    label: '备注',
    formatter: ({ remarks }: any) => {
      return remarks || '-'
    },
  },
]

const onModel = ({ id }: any) => {
  router.push({
    path: '/product/template/model-detail',
    query: {
      id,
    },
  })
}

const toDelete = ({ id }: any) => {
  msgbox({
    tip: '你确定要删除这个模板吗？',
    thenFn: () => handleDelete({ id }),
  })
}

const handleDelete = async ({ id }: any) => {
  const res: any = await deviceThingTemplateDelete({ id })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessage.success('操作成功')
  }

  fetchList()
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        onClick: toTemplateForm,
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode("添加产品模板")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        class: "ws_common_table ws_mt20",
        data: tableData.value
      }, {
        empty: _withCtx(() => [
          _createVNode(_component_el_empty, { description: "暂无数据" })
        ]),
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(col, (item, index) => {
            return _createVNode(_component_el_table_column, {
              key: index,
              prop: item.prop,
              label: item.label,
              formatter: item.formatter,
              "show-overflow-tooltip": ""
            }, null, 8, ["prop", "label", "formatter"])
          }), 64)),
          _createVNode(_component_el_table_column, {
            width: 320,
            label: "操作"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_unref(OperationButtonList), {
                buttonList: buttonList.value,
                scope: scope.row,
                onOnModel: onModel,
                onOnDelete: toDelete,
                onOnEdit: toTemplateForm
              }, null, 8, ["buttonList", "scope"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, tableLoading.value]
      ]),
      _createVNode(_component_el_pagination, {
        class: "ws_mt50",
        "current-page": pageParams.value.curPage,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((pageParams.value.curPage) = $event)),
        "page-size": pageParams.value.pageSize,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageParams.value.pageSize) = $event)),
        "page-sizes": _unref(PAGE_SIZES),
        layout: "->, total, sizes, prev, pager, next, jumper ",
        total: total.value,
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
    ]),
    _createVNode(TemplateForm, {
      visible: templateConf.value.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((templateConf.value.visible) = $event)),
      data: templateConf.value.data,
      onSuccess: fetchList
    }, null, 8, ["visible", "data"])
  ]))
}
}

})